// extracted by mini-css-extract-plugin
module.exports = {"top":"Layout_top__1ao44","topBottomGutter":"Layout_topBottomGutter__3JAQw"};